import { render, staticRenderFns } from "./AdvertiserCard.vue?vue&type=template&id=5df413c1&scoped=true&"
import script from "./AdvertiserCard.vue?vue&type=script&lang=js&"
export * from "./AdvertiserCard.vue?vue&type=script&lang=js&"
import style0 from "./AdvertiserCard.vue?vue&type=style&index=0&id=5df413c1&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df413c1",
  null
  
)

export default component.exports